module.exports = __webpack_public_path__ + "assets/koenigs_apo_slider2.ea060c93.jpeg";